// to help with styling in prerendering (eg prerender.io) - see https://github.com/styled-components/styled-components/blob/master/CHANGELOG.md#v410---2018-11-12
global.SC_DISABLE_SPEEDY = true;
